'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _inputRadio = _interopRequireDefault(require("./input-radio"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var InputRadioGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(InputRadioGroup, _React$Component);

  function InputRadioGroup(props) {
    var _this;

    _classCallCheck(this, InputRadioGroup);

    _this = _possibleConstructorReturn(this, (InputRadioGroup.__proto__ || Object.getPrototypeOf(InputRadioGroup)).call(this, props));
    _this.state = {
      helpIsHidden: true,
      fieldIsHidden: true
    };
    _this.update = _this.update.bind(_assertThisInitialized(_this));
    _this.toggleInfoBlock = _this.toggleInfoBlock.bind(_assertThisInitialized(_this));
    _this.toggleOptionalBlock = _this.toggleOptionalBlock.bind(_assertThisInitialized(_this));
    _this.hideOptionalBlock = _this.hideOptionalBlock.bind(_assertThisInitialized(_this));
    _this.deleteFieldAndHideOptionalBlock = _this.deleteFieldAndHideOptionalBlock.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputRadioGroup, [{
    key: "update",
    value: function update(event) {
      var target = event.target;
      this.props.onChange(event, target.name, target.value);
    }
  }, {
    key: "toggleInfoBlock",
    value: function toggleInfoBlock(e) {
      e.preventDefault();
      this.setState(function (prevState) {
        return {
          helpIsHidden: !prevState.helpIsHidden
        };
      });
    }
  }, {
    key: "toggleOptionalBlock",
    value: function toggleOptionalBlock(e) {
      e.preventDefault();
      this.setState(function (prevState) {
        return {
          fieldIsHidden: !prevState.fieldIsHidden
        };
      });
    }
  }, {
    key: "hideOptionalBlock",
    value: function hideOptionalBlock(e) {
      e.preventDefault();
      this.setState(function (prevState) {
        return {
          fieldIsHidden: !prevState.fieldIsHidden
        };
      });
    }
  }, {
    key: "deleteFieldAndHideOptionalBlock",
    value: function deleteFieldAndHideOptionalBlock(e) {
      this.props.onChange(e, this.props.name, false);
      this.hideOptionalBlock(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var hasError = this.props.errors ? this.props.errors[this.props.name] : false,
          inputClasses = 'form-field',
          value = this.props.value,
          error;

      if (hasError) {
        error = this.props.errors[this.props.name].map(function (errorMsg) {
          return _this2.props.t(errorMsg);
        }).join(', ');
      }

      if (hasError) {
        inputClasses += ' ' + 'error';
      }

      if (this.props.disabled) {
        inputClasses += ' ' + 'disabled';
      }

      if (value === 0 || value === 1 || value === true || value === false) {//checked = !!value; // TODO: verify that we can remove it
      }

      var radioClasses = 'radio-group';

      if (this.props.radioInline) {
        radioClasses += ' ' + 'radio-inline';
      }

      var renderInfoBlock = '';
      var iconOffset = '';

      if (this.props.infoText) {
        var infoTextClass = this.state.helpIsHidden ? 'info-text hidden' : 'info-text';
        iconOffset = 'iconOffset'; // add margin to Optional tag so it not overlap icon

        renderInfoBlock = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
          className: 'icon icon-help primary',
          onClick: this.toggleInfoBlock
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: infoTextClass
        }, this.props.infoText));
      }

      var renderOptionalFormLink = '';
      var renderOptionalTag = '';
      var renderOptionalCloseButton = '';
      var optionalFieldClass = this.state.fieldIsHidden ? 'optional-form-field hidden' : 'optional-form-field';

      if (this.props.optional) {
        renderOptionalFormLink = /*#__PURE__*/_react.default.createElement("div", {
          className: 'optional-form-link',
          onClick: this.toggleOptionalBlock
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: 'icon icon-add'
        }), /*#__PURE__*/_react.default.createElement("h3", null, this.props.label));
        renderOptionalTag = /*#__PURE__*/_react.default.createElement("span", {
          className: iconOffset
        }, t('Optional'));
        renderOptionalCloseButton = /*#__PURE__*/_react.default.createElement("span", {
          className: 'close-optional',
          onClick: this.deleteFieldAndHideOptionalBlock
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: "javascript: void(0)"
        }, t('Delete field')));
      } else {
        optionalFieldClass = 'optional-form-field';
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: inputClasses
      }, renderOptionalFormLink, /*#__PURE__*/_react.default.createElement("div", {
        className: optionalFieldClass
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'label-container',
        "data-equalize": true
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: 'label'
      }, this.props.label ? this.props.label : ''), /*#__PURE__*/_react.default.createElement("span", {
        className: 'label-description'
      }, renderInfoBlock, renderOptionalTag)), /*#__PURE__*/_react.default.createElement("div", {
        className: radioClasses
      }, this.props.options.map(function (option, key) {
        if (option.isHeading) return /*#__PURE__*/_react.default.createElement("h3", {
          key: key
        }, option.title);
        return /*#__PURE__*/_react.default.createElement(_inputRadio.default, {
          key: key,
          name: _this2.props.name,
          checked: option.id === _this2.props.value,
          disabled: _this2.props.disabled,
          id: option.id + (_this2.props.id !== undefined ? _this2.props.id : ''),
          value: option.id,
          label: option.label || t(option.name),
          click: _this2.update
        });
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: 'error-message'
      }, hasError ? error : ''), renderOptionalCloseButton));
    }
  }]);

  return InputRadioGroup;
}(_react.default.Component);

InputRadioGroup.propTypes = {
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  label: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  options: _propTypes.default.array.isRequired,
  radioInline: _propTypes.default.bool,
  value: _propTypes.default.any,
  disabled: _propTypes.default.bool,
  infoText: _propTypes.default.string,
  optional: _propTypes.default.bool,
  t: _propTypes.default.func.isRequired,
  errors: _propTypes.default.object
};
InputRadioGroup.defaultProps = {
  optional: false,
  infoText: null,
  disabled: false
};
var _default = InputRadioGroup;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/radio-group.js
// module id = 541
// module chunks = 0